export class ReportRow {
    constructor({
        id,
        expense_id,
        expense_title,
        amount,
        currency,
        details,
        Beneficiary,
    }) {
        this.id = id;
        this.expenseId = expense_id;
        this.expenseTitle = expense_title;
        this.amount = amount;
        this.currency = currency;
        this.details = details;
        this.beneficiary = Beneficiary;

        Object.freeze(this);
    }
}

export default class Report {
    constructor({
        id,
        title,
        processed,
        row_count,
        assigned_row_count = 0,
        created_at,
        rows = [],
    }) {
        this.id = id;
        this.title = title;
        this.processed = processed;
        this.rowCount = row_count;
        this.assignedRowCount = assigned_row_count;
        this.createdAt = created_at;
        this.rows = rows.map((row) => new ReportRow(row));

        Object.freeze(this);
    }

    get hasRows() {
        return this.rows.length > 0;
    }
}
